import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { getAppDisplayName } from '../utils/commonMethods';

interface ConfirmationAlertProps {
    onDelete: () => void;
    message: string;
    open: boolean;
    handleClose: () => void;
}

const ConfirmationAlert: React.FC<ConfirmationAlertProps> = ({
    onDelete,
    message,
    open,
    handleClose,
}) => {


    const handleDelete = () => {
        onDelete();
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {getAppDisplayName()}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{"NO"}</Button>
                <Button onClick={handleDelete} >
                    {"YES"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationAlert;
